<template>
  <div class="animated revealUp">
    <div class>
      <div class="section-title mb-4">
        {{ $t("add") }} {{ $t("goodreturn") }}
      </div>
    </div>
    <div class="white-wrapper">
      <div class="mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-4 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
                placeholder="."
                name="mapcinema"
                id="mapcinema"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaKey) in Cinemas"
                  :key="cinemaKey"
                  v-on:click="onSelectCinema(cinema.cine_id, cinema.cine_name)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedCinema.length == 0"
                >Please select cinema.</span
              >
            </p>
          </div>

          <!-- SELECT PO -->
          <div class="col-lg-4 col-xl-4 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedPurchaseOrder.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("purchase", 2) }}
                {{ $tc("order", 2) }}</label
              >
              <b-dropdown
                :text="selectedPurchaseOrder"
                variant="dropdown-curve"
                class="w-100"
                name="mapcinema"
                id="mapcinema"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search PO"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchPO()"
                    v-on:keydown="onSearchPO()"
                    v-on:search="onSearchPO()"
                    v-model="searchPO"
                  />
                </div>
                <b-dropdown-item
                  v-for="(po, poKey) in poArray"
                  :key="poKey"
                  v-on:click="onSelectPO(po.po_id, po.po_number)"
                  >{{ po.po_number }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedPurchaseOrder.length == 0"
                >Please select purchase order.</span
              >
            </p>
          </div>

          <div class="col-lg-4 col-xl-4 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedVendor.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("vendor", 1) }}</label
              >
              <b-dropdown
                disabled
                :text="selectedVendor"
                variant="dropdown-curve"
                class="w-100"
                name="mapcinema"
                id="mapcinema"
              ></b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedVendor.length == 0"
                >Please select vendor.</span
              >
            </p>
          </div>

          <div class="col-md-12 mb-3 font-weight-bold">{{ $t("items") }}</div>

          <div
            v-for="(rawMaterial, rawMaterialKey) in RawMaterials"
            :key="rawMaterialKey"
            class="col-md-12 mb-4"
          >
            <div class="row" style="border-bottom: 0.1px solid lightgrey">
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="rawMaterial.rm_name.length > 0 ? 'shift-up' : ''"
                      >{{ $tc("rawmaterials", 2) }}</label
                    >
                    <b-dropdown
                      :text="rawMaterial.rm_name"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Raw Material"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchRawMaterial($event.target.value)"
                          v-on:search="onSearchRawMaterial($event.target.value)"
                          v-on:keydown="
                            onSearchRawMaterial($event.target.value)
                          "
                          v-model="searchRawMaterial"
                        />
                      </div>
                      <b-dropdown-item
                        v-for="(rawMaterialName,
                        rawMaterialNameKey) in purchasOrderDetails"
                        :key="rawMaterialNameKey"
                        v-on:click="
                          onSelectRawMaterial(
                            rawMaterialName,
                            rawMaterialKey,
                            rawMaterialNameKey
                          )
                        "
                        >{{ rawMaterialName.rm_name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
                <p
                  v-if="submitted && rawMaterial.rm_name.length == 0"
                  class="error_message"
                >
                  <span>Please select raw material.</span>
                </p>
                <span
                  class="mt-1"
                  v-if="rawMaterial.rm_name && rawMaterial.rm_name.length > 0"
                  >(Max Quantity {{ rawMaterial.max_qty }})</span
                >
              </div>

              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <!-- <b-dropdown
                      :text="rawMaterial.fgr_quantity"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(loop, loopIndex) in 500"
                        :key="loopIndex"
                        v-on:click="onSelectQuantity(loop,rawMaterialKey)"
                      >{{loop}}</b-dropdown-item>
                  </b-dropdown>-->
                  <!-- <b-input-group> -->
                  <div class="input-material">
                    <!-- style="border-radius:10px" -->
                    <input
                    style="text-align:right"
                      v-model="rawMaterial.fgr_quantity"
                      type="number"
                      placeholder="."
                      name="good_return_qty"
                      id="good_return_qty"
                      @keyup="
                        CalculateSelectedRawMaterial(
                          $event.target.value,
                          rawMaterialKey
                        )
                      "
                    />
                    <label>{{ $t("quantity") }}</label>
                    <!-- </b-input-group> -->
                  </div>
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label
                      :class="rawMaterial.uom_name.length > 0 ? 'shift-up' : ''"
                      >{{ $t("select") }} UOM</label
                    >
                    <b-dropdown
                      disabled
                      :text="rawMaterial.uom_name"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(UomName, UomNameIndex) in rawMaterial.uom_units"
                        :key="UomNameIndex"
                        v-on:click="onSelectUom(UomName, rawMaterialKey)"
                        >{{ UomName.uom_short_form }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
                <p class="error_message">
                  <span v-if="submitted && rawMaterial.uom_name.length == 0"
                    >Please select unit of measurement.</span
                  >
                </p>
              </div>

              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                    style="text-align:right"
                      v-model="rawMaterial.fgr_return_rate"
                      name="rate"
                      id="rate"
                      type="number"
                      placeholder="."
                    />
                    <label>{{ $t("rate") }}</label>
                  </div>
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-md-2">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                    style="text-align:right"
                      v-model="rawMaterial.fgr_return_amount"
                      name="totalamount"
                      id="totalamount"
                      type="number"
                      placeholder="."
                    />
                    <label>{{ $t("amount") }}</label>
                  </div>
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div class="col-md-2 mt-2" v-if="false">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                    style="text-align:right"
                      v-model="rawMaterial.returnable_quantity"
                      name="returnable"
                      id="returnable"
                      type="number"
                      placeholder="."
                    />
                    <label>{{ $t("returnable") }} {{ $t("quantity") }}</label>
                  </div>
                </div>
                <p class="error_message">
                  <span></span>
                </p>
              </div>

              <div
                class="col-md-1 border-left d-flex align-items-center justify-content-center mb-4"
              >
                <div class="col-md-3 align-self-center">
                  <button
                    v-if="rawMaterialKey == 0"
                    @click="addRawMaterial()"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                  <button
                    v-else
                    @click="removeRawMaterial(rawMaterialKey)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="fnb_goods_return.fgr_return_date"
                    name="purchasedate"
                    disabled
                    id="purchasedate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label
                    :class="
                      fnb_goods_return.fgr_return_date &&
                      typeof fnb_goods_return.fgr_return_date === 'object'
                        ? 'active'
                        : ''
                    "
                    >{{ $t("goodreturn") }} {{ $t("date") }}</label
                  >
                </div>
              </div>
              <Tooltip :title="$t('purchaseOrder_PurchaseOrderDate')" />
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="fnb_goods_return.fgr_remarks"
                  name="fgr_remarks"
                  id="fgr_remarks"
                  placeholder="."
                  v-validate="'required'"
                />
                <label>{{ $t("remarks") }}</label>
              </div>
              <Tooltip :title="$t('description_tooltip')" />
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('fgr_remarks')">{{
                errors.first("fgr_remarks")
              }}</span>
            </p>
          </div>

          <div class="col-md-4 d-flex">
            <label class="mr-2">{{ $t("active") }}</label>
            <label class="ios-switch ml-2">
              <input
                v-model="fnb_goods_return.fgr_is_active"
                type="checkbox"
                class="ios-checkbox"
                checked
              />
              <span class="switch-slider"></span>
            </label>
          </div>

          <!-- <div class="col-md-4">Total: INR</div> -->
        </div>

        <section class="mt-3">
          <div class="col-md-12 text-center">
            <button
              :disabled="btenable"
              @click="onFinalSubmit(false)"
              class="btn-blue"
            >
              {{ $t("save") }}
            </button>
            <button
              :disabled="btenable"
              @click="onFinalSubmit(true)"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button>
            <button @click="onResetForm()" class="btn-black">
              {{ $t("reset") }}
            </button>
            <b-button
              class="btn-outline-grey"
              variant="default"
              to="good-return"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";

export default {
  // name: "Add Goods Return",
  data() {
    return {
      submitted: false,
      POListCopy: [],
      searchPO: "",
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: "",
      selectedCinema: "",
      Cinemas: [],
      selectedPurchaseOrder: "",
      selectedVendor: "",
      POList: [],
      fnb_goods_return: {
        cinema_id: null,
        purchase_order_id: null,
        vendor_id: null,
        fgr_return_date: new Date(),
        fgr_remarks: "",
        fgr_is_active: true
      },
      rm_id: null,
      stock_in_id: null,
      searchRawMaterial: "",
      purchasOrderDetails: [],
      // purchasOrderDetails: [],
      UnitMeasurement: [],
      RawMaterials: [
        {
          rm_id: "",
          rm_name: "",
          uom_id: "",
          uom_name: "",
          max_qty: "",
          fgr_quantity: "",
          fgr_return_rate: "",
          fgr_return_amount: "",
          fgr_return_rate_copy: "",
          fgr_return_amount_copy: "",
          poi_qty: "",
          returnable_quantity: "",
          uom_units: []
        }
      ]
    };
  },
  async beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    await this.getCinemasList(obj);
    await this.getPurchasOrderList();
    //
    this.fnb_goods_return.cinema_id = this.$route.query.cinema_id;
    this.fnb_goods_return.purchase_order_id = this.$route.query.po_id;
    this.rm_id = this.$route.query.rm_id;
    this.stock_in_id = this.$route.query.stock_in_id;
    if (
      this.fnb_goods_return.cinema_id &&
      this.fnb_goods_return.purchase_order_id &&
      this.rm_id &&
      this.stock_in_id
    ) {
      await this.getCinemasList(this.fnb_goods_return.cinema_id);
      await this.getOrdersDetails(this.fnb_goods_return.purchase_order_id);
      await this.getRawMaterialBasedQuantity();
    }
  },
  computed: {
    poArray() {
      let tempArr = [];
      if(this.fnb_goods_return.cinema_id) {
        tempArr = this.POList.filter((x) => x.cinema_id == this.fnb_goods_return.cinema_id)
      }
      return tempArr
    },
  },
  methods: {
    onSearchPO: function() {
      if (this.searchPO && this.searchPO.length > 0) {
        this.POList = this.POListCopy.filter(x => {
          if (x.po_number.toLowerCase().includes(this.searchPO.toLowerCase())) {
            return x;
          }
        });
      } else {
        this.POList = this.POListCopy;
      }
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onSearchRawMaterial: function(value) {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.purchasOrderDetails = this.purchasOrderDetailsCopy.filter(x => {
          if (
            x.rm_name
              .toLowerCase()
              .includes(this.searchRawMaterial.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.purchasOrderDetails = this.purchasOrderDetailsCopy;
      }
    },
    getRawMaterialBasedQuantity: function() {
      let payload = {
        cinema_id: this.fnb_goods_return.cinema_id,
        po_id: this.fnb_goods_return.purchase_order_id,
        rm_id: this.rm_id,
        stock_in_id: this.stock_in_id
      };
      PosFnbService.GetRemainingQuantity(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            let obj1 = data.Records[1];

            this.selectedPurchaseOrder = obj1.po_number;
            this.RawMaterials[0].rm_id = obj1.rm_id;
            this.RawMaterials[0].rm_name = obj.rm_name;
            this.RawMaterials[0].uom_id = obj.uom_id;
            this.RawMaterials[0].uom_name = obj.uom_unit;
            this.RawMaterials[0].fgr_quantity = obj.final_stock_quantity;
            this.RawMaterials[0].max_qty = obj.final_stock_quantity;
            this.RawMaterials[0].fgr_return_rate = obj1.poi_price;
            this.RawMaterials[0].fgr_return_rate_copy = obj1.poi_price;
            this.RawMaterials[0].fgr_return_amount = obj1.poi_total_amount;
            this.RawMaterials[0].fgr_return_amount_copy = obj1.poi_total_amount;
            this.RawMaterials[0].poi_qty = obj1.poi_qty;
            this.getRawMaterialQtyAndPrice(
              0,
              this.rm_id,
              this.fnb_goods_return.purchase_order_id,
              this.fnb_goods_return.cinema_id
            );
            // this.getRelatedUom(0, this.rm_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$toasted.show(err);
        });
    },
    getRelatedUom: function(index, rm_id) {
      let cinema_id = this.fnb_goods_return.cinema_id
      PosFnbService.getUomFromRawMaterial({ rm_id , cinema_id: cinema_id})
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.RawMaterials[index].uom_units = data.Records;
            this.UnitMeasurement = data.UnitMeasurement;
            let CheckUnit = this.UnitMeasurement.filter(x => {
              return x.conversion_from == this.RawMaterials[index].uom_id;
            });
            // if (CheckUnit.length > 0) {
            //   this.RawMaterials[index].fgr_quantity = parseInt(
            //     this.RawMaterials[index].fgr_quantity /
            //       parseInt(CheckUnit[0].conversion_formula)
            //   );
            //   this.RawMaterials[index].max_qty = parseInt(
            //     this.RawMaterials[index].max_qty /
            //       parseInt(CheckUnit[0].conversion_formula)
            //   );
            //   this.RawMaterials[index]["conversion_formula"] = parseInt(
            //     CheckUnit[0].conversion_formula
            //   );
            // } else {
            //   this.RawMaterials[index].fgr_quantity = parseInt(
            //     this.RawMaterials[index].fgr_quantity
            //   );
            //   this.RawMaterials[index].max_qty = parseInt(
            //     this.RawMaterials[index].max_qty
            //   );
            //   this.RawMaterials[index]["conversion_formula"] = 1;
            // }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getCinemasList: function(cine_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                this.onSelectCinema(x.cine_id, x.cine_name);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema(cinema_id, cinema_name) {
      this.selectedCinema = cinema_name;
      this.fnb_goods_return.cinema_id = cinema_id;
      this.searchCinema = "";
      this.onSearchCinema();
      this.resetPoDetails();
    },
    getPurchasOrderList: function() {
      let payload = {
        tableName: "purchase_orders",
        po_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.POList = data.Records;
            this.POListCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    resetPoDetails() {
      this.purchasOrderDetails = [];
      this.selectedPurchaseOrder = "";
      this.fnb_goods_return.purchase_order_id = null;
      this.searchPO = "";
    },
    onSelectPO: function(po_id, po_number) {
      this.selectedPurchaseOrder = po_number;
      this.fnb_goods_return.purchase_order_id = po_id;
      this.searchPO = "";
      this.onSearchPO();
      this.getOrdersDetails(po_id);
    },
    getOrdersDetails: function(po_id) {
      this.purchasOrderDetails = [];
      let loader = this.$loading.show();
      let payload = {
        po_id: po_id
      };
      PosFnbService.GetPurchaseOrderDetails(payload)
        .then(async response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.purchasOrderDetails = data.Records;
            this.selectedPurchaseOrder = data.Records[0].po_number;
            this.fnb_goods_return.purchase_order_id = data.Records[0].po_id;
            await this.getVendorsList(this.purchasOrderDetails[0].v_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          setTimeout(() => loader.hide(), 1100);
        });
    },
    getVendorsList: function(v_id) {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map(x => {
              if (x.v_id == v_id) {
                this.selectedVendor = x.v_name;
                this.fnb_goods_return.vendor_id = v_id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onSelectRawMaterial: function(params, index, rawkey) {
      this.RawMaterials[index].rm_name = params.rm_name;
      this.RawMaterials[index].rm_id = String(params.rm_id);
      this.RawMaterials[index].uom_name = params.uom_unit;
      this.RawMaterials[index].uom_id = params.uom_id;

      this.getRawMaterialQtyAndPrice(
        index,
        params.rm_id,
        this.fnb_goods_return.purchase_order_id,
        this.fnb_goods_return.cinema_id
      );
    },
    getRawMaterialQtyAndPrice(index, rm_id, po_id, cinema_id) {
      PosFnbService.GetRawMaterialQtyAndPrice({ rm_id, po_id, cinema_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            let obj1 = data.Records[1];
            let singleRate = parseFloat(obj1.poi_price) / parseFloat(obj1.poi_qty)
            let singleAmount = parseFloat(obj1.poi_total_amount) / parseFloat(obj1.poi_qty)
            this.RawMaterials[index].fgr_quantity = obj.final_stock_quantity;
            this.RawMaterials[index].max_qty = obj.final_stock_quantity;
            this.RawMaterials[index].fgr_return_rate = parseFloat(obj.final_stock_quantity * singleRate).toFixed(2);
            this.RawMaterials[index].fgr_return_rate_copy = parseFloat(obj.final_stock_quantity * singleRate).toFixed(2);
            this.RawMaterials[index].fgr_return_amount = parseFloat(obj.final_stock_quantity * singleAmount).toFixed(2);
            this.RawMaterials[index].fgr_return_amount_copy =
              parseFloat(obj.final_stock_quantity * singleAmount).toFixed(2);
            this.RawMaterials[index].poi_qty = obj1.poi_qty;
            this.getRelatedUom(index, rm_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$toasted.show(err);
        });
    },
    onSelectQuantity: function(params, index) {
      this.RawMaterials[index]["fgr_quantity"] = params.toString();
    },
    onSelectUom: function(params, index) {
      this.RawMaterials[index].uom_name = params.uom_unit;
      this.RawMaterials[index].uom_id = params.uom_id;
    },
    addRawMaterial: function() {
      this.RawMaterials.push({
        rm_id: "",
        rm_name: "",
        uom_id: "",
        uom_name: "",
        fgr_quantity: "",
        fgr_return_rate: "",
        fgr_return_amount: "",
        fgr_return_rate_copy: "",
        fgr_return_amount_copy: "",
        max_qty: "",
        poi_qty: "",
        returnable_quantity: "",
        uom_units: []
      });
    },
    removeRawMaterial(index) {
      this.RawMaterials.splice(index, 1);
    },
    clearSelectedDate: function() {
      this.fnb_goods_return.fgr_return_date = "";
    },
    CalculateSelectedRawMaterial: function(value, index) {
      console.log('COMING HERE');
      if (
        this.RawMaterials[index].max_qty &&
        value > this.RawMaterials[index].max_qty
      ) {
        this.RawMaterials[index].fgr_quantity = this.RawMaterials[
          index
        ].max_qty;
        this.$toasted.show(
          "Max quantity is " + this.RawMaterials[index].fgr_quantity
        );
      } else {
        this.RawMaterials[index].fgr_quantity = value;
      }
      //Calculate price
      let singleItemPrice =
        parseFloat(this.RawMaterials[index].fgr_return_rate_copy) /
        parseFloat(this.RawMaterials[index].max_qty);
      let singleItemTotalPrice =
        parseFloat(this.RawMaterials[index].fgr_return_amount_copy) /
        parseFloat(this.RawMaterials[index].max_qty);
      this.RawMaterials[index].fgr_return_rate =
        parseFloat(singleItemPrice * parseFloat(this.RawMaterials[index].fgr_quantity)).toFixed(2);
      this.RawMaterials[index].fgr_return_amount =
        parseFloat(singleItemTotalPrice * parseFloat(this.RawMaterials[index].fgr_quantity)).toFixed(2);
    },
    onResetForm: function() {
      this.fnb_goods_return = {
        cinema_id: null,
        purchase_order_id: null,
        vendor_id: null,
        fgr_return_date: new Date(),
        fgr_is_active: true
      };
      this.RawMaterials = [
        {
          rm_id: "",
          rm_name: "",
          uom_id: "",
          uom_name: "",
          fgr_quantity: "",
          fgr_return_rate: "",
          fgr_return_amount: "",
          fgr_return_rate_copy: "",
          fgr_return_amount_copy: "",
          returnable_quantity: ""
        }
      ];
      this.selectedCinema = "";
      this.selectedPurchaseOrder = "";
      this.selectedVendor = "";
    },
    RawMaterialValidation: function() {
      let count = 0;

      this.RawMaterials.map(x => {
        if (x.rm_id.length == 0 || x.uom_id.length == 0) {
          count++;
        }
      });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    onFinalSubmit: function(flag) {
      this.submitted = true;

      this.$validator.validate().then(valid => {
        if (
          this.fnb_goods_return.cinema_id == null ||
          this.fnb_goods_return.purchase_order_id == null ||
          this.fnb_goods_return.vendor_id == null
        ) {
          return;
        }
        if (this.RawMaterialValidation()) {
          return;
        }
        if (valid) {
          // this.btenable = true;
          let array = this.RawMaterials.filter(x => {
            return x.fgr_quantity <= 0;
          });
          // console.log(this.RawMaterials);
          // return false

          let checkArray = this.RawMaterials.filter(x => {
            return parseInt(x.returnable_quantity) > parseInt(x.max_qty);
          });
          if (checkArray.length > 0) {
            this.$toasted.show(
              checkArray[0].rm_name +
                " return quantity is more than  max quantity"
            );
            return false;
          }
          let payload = {
            fnb_goods_return: this.fnb_goods_return,
            RawMaterials: this.RawMaterials
          };
          if (array && array.length == 0) {
            PosFnbService.AddGoodsReturn(payload)
              .then(response => {
                this.btenable = false;
                const { data } = response;
                if (data.status) {
                  if (flag) {
                    this.onResetForm();
                  } else {
                    this.$router.push({
                      path: "good-return"
                    });
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          } else {
            this.$toasted.show(
              array[0].rm_name + " quantity is less than or equal to 0"
            );
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/GoodReturn/addGoodReturn.vue